/**
 * useStatusBanner — TanStack Query Hook fuer Status-Banner-Polling (W0.6)
 *
 * - staleTime: 30s
 * - refetchInterval: 60s
 * - retry: false (silent fail bei Netzwerk-Fehler)
 * - throwOnError: false (kein Error-Boundary-Trigger)
 *
 * Der Endpoint /api/v2/status ist public — kein Auth-Token erforderlich.
 * Wir umgehen den apiClient (der global einen Authorization-Header setzt)
 * und machen einen direkten fetch ohne Auth.
 */
import { useQuery } from '@tanstack/react-query'

export type StatusResponse = {
  active: boolean
  message: string
  severity: 'info' | 'warning'
}

async function fetchStatus(): Promise<StatusResponse> {
  const baseUrl = (import.meta as { env?: Record<string, string> }).env?.VITE_API_BASE_URL ?? ''
  const res = await fetch(`${baseUrl}/api/v2/status`)
  if (!res.ok) throw new Error(`Status fetch failed: ${res.status}`)
  return res.json() as Promise<StatusResponse>
}

export function useStatusBanner() {
  return useQuery<StatusResponse>({
    queryKey: ['status-banner'],
    queryFn: fetchStatus,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
    throwOnError: false,
  })
}
